import { IS_PRODUCTION_MODE } from '@/config/config';

export const API_URL = 'https://junkit.vonigo.com/api/v1/';

// OPTIONS
export const PAYMENTS = "data/Payments/";

export const CHECK_PROMOTION = "resources/promos/";

// LOCATION
export const LOCATION = "data/Locations/";

export const FRANCHISE = 'security/franchises/';
export const CHANGE_FRANCHISE = 'security/session/';

export const CHECK_API = "resources/franchises/";

// SERVICE
export const LOGIN = "security/login/";
export const LOGOUT = "security/logout/";

export const OBJECTS = "system/objects/";

// JOB
export const JOB = "data/Jobs/";

// WORK ORDER
export const WORK_ORDER = "data/WorkOrders/";

// CONTACT
export const CONTACT = 'data/Contacts/';

// TIME AVAILABLE
export const TIME_AVAILABLE = "Resources/availability/";


// CLIENTS
export const CLIENTS = 'data/Clients/';

// PRICE LIST
export const PRICE_LISTS = 'Resources/priceLists/';
export const PRICE_BLOCKS = 'Resources/priceBlocks/';
export const PRICE_ITEMS = 'resources/priceItems/';
export const BUFFER_TIME = 'resources/zips/';

export const SERVICES_TYPES = 'resources/servicetypes/';

export const AUTHORIZE_PAYMENT = 'https://api.authorize.net/xml/v1/request.api'
